"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyUnlockedWorkoutGet = void 0;
exports.unlockedWorkoutGetSetMock = unlockedWorkoutGetSetMock;
exports.unlockedWorkoutGet = unlockedWorkoutGet;
exports.useQueryUnlockedWorkoutGet = useQueryUnlockedWorkoutGet;
exports.useInfiniteQueryUnlockedWorkoutGet = useInfiniteQueryUnlockedWorkoutGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function unlockedWorkoutGetSetMock(mock) {
    setMock = mock;
}
async function unlockedWorkoutGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v2/dashboard/unlocked-workout/${params.softwareNumber}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.equipmentType = params.equipmentType;
    queryParams.userType = params.userType;
    queryParams.date = params.date;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyUnlockedWorkoutGet = 'wolf-dashboard-service:unlockedWorkoutGet:get';
function useQueryUnlockedWorkoutGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUnlockedWorkoutGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryUnlockedWorkoutGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyUnlockedWorkoutGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = unlockedWorkoutGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=unlocked-workout-get.js.map